import {
  Slider,
  SliderProps,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import { ProgressStatCardProps } from "./progress-stat-card-props";

interface riskScaleProps {
  [key: string]: number;
}

export const ProgressBarUnlocked = ({
  title,
  progressValue,
  caption,
  value,
  ...rest
}: Pick<
  ProgressStatCardProps,
  "title" | "progressValue" | "caption" | "value"
> &
  SliderProps) => {
  const riskScale: riskScaleProps = {
    "Very High": 90,
    "Relatively High": 70,
    "Relatively Moderate": 50,
    "Relatively Low": 30,
    "Very Low": 10,
  };

  let sliderValue: number | undefined;

  if (caption?.includes("FEMA")) {
    const risk = Object.keys(riskScale).find((key) => key === value);
    sliderValue = risk ? riskScale[risk] : undefined;
  } else {
    sliderValue = progressValue;
  }

  return (
    <Slider
      aria-label={title + "-metered-value"}
      defaultValue={sliderValue}
      isReadOnly
      {...rest}
    >
      <SliderTrack
        bgGradient={
          value === "No Rating"
            ? "gray"
            : "linear(to-r, green.300, yellow.300, red.500)"
        }
        borderRadius="lg"
        h="1"
      ></SliderTrack>
      {value === "No Rating" ? (
        <></>
      ) : (
        <SliderThumb
          boxSize={4}
          borderColor="green.500"
          borderWidth="3px"
        ></SliderThumb>
      )}
    </Slider>
  );
};
